import React from 'react';

function fmtTimer(s) {
  const m = Math.floor(s / 60);
  const rem = s % 60;
  return `${m}:${String(rem).padStart(2, '0')}`;
}

export default function ExamReview({
  questions,
  answers,
  flagged,
  currentIdx,
  elapsedSecs,
  onJump,
  onSubmit,
  submitting,
}) {
  const total = questions.length;
  const answeredCount = answers.filter((a) => a && a.selected_answer).length;
  const flaggedCount = Object.values(flagged).filter(Boolean).length;

  return (
    <div className="bg-bg-card rounded-r-xl border border-border-soft">
      <div className="px-sp-6 py-sp-5">
        <p className="text-[15px] font-semibold text-text-primary mb-sp-1">Review your answers</p>
        <p className="text-sm text-text-muted mb-sp-4">
          Click any question to change your answer. Flagged questions are highlighted.
        </p>

        <div className="grid grid-cols-10 gap-sp-2 mb-sp-4">
          {questions.map((_, i) => {
            const isAnswered = answers[i] && answers[i].selected_answer;
            const isFlagged = !!flagged[i];
            const isCurrent = i === currentIdx;

            let cls = 'border border-border-soft bg-bg-card text-text-secondary';
            if (isAnswered) {
              cls = 'bg-[#DBEAFE] border border-[#93C5FD] text-[#1e40af]';
            }
            if (isFlagged) {
              cls = 'bg-[#FDE68A] border border-[#F59E0B] text-[#78350F]';
            }
            const currentRing = isCurrent ? 'ring-2 ring-navy' : '';

            return (
              <button
                key={i}
                onClick={() => onJump(i)}
                className={`aspect-square rounded-r-md flex items-center justify-center text-sm font-semibold cursor-pointer transition-colors ${cls} ${currentRing}`}
              >
                {i + 1}
              </button>
            );
          })}
        </div>

        <div className="flex gap-sp-5 mb-sp-5 text-sm">
          <div className="flex items-center gap-sp-2">
            <span className="w-[14px] h-[14px] rounded-[4px] bg-[#DBEAFE] border border-[#93C5FD]" />
            <span className="text-text-secondary font-medium">Answered</span>
          </div>
          <div className="flex items-center gap-sp-2">
            <span className="w-[14px] h-[14px] rounded-[4px] bg-[#FDE68A] border border-[#F59E0B]" />
            <span className="text-text-secondary font-medium">Flagged</span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <p className="text-sm text-text-secondary">
            {answeredCount} answered · {flaggedCount} flagged · {fmtTimer(elapsedSecs)} elapsed
          </p>
          <button
            onClick={onSubmit}
            disabled={submitting}
            className="px-sp-5 py-sp-3 text-sm font-medium bg-accent text-white rounded-r-md hover:bg-accent-hover transition-colors active:scale-[0.98] disabled:opacity-40 disabled:cursor-not-allowed"
          >
            {submitting ? 'Submitting…' : 'Submit exam'}
          </button>
        </div>
      </div>
    </div>
  );
}
